module.exports = __webpack_public_path__ + "img/cjj_dy.9939c4bf.jpg";